import React, { useState, useEffect, useRef } from 'react'
import moment from "moment"
import { Box, TextField, Chip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getNumDaysFromDateRange, getNumMonths, getNumWeeks, calcWeeksInMonth, dateFormat } from "../../../app/util"
import './groupCustomCalendar.css';
import Week from './Week';
function GroupCustomCalendar({ modifyCalendarDates, asOfDate,
    changeDateRange, selectedDates,
    weekdaysSelection = "enabled", rangeInput = "enabled" }) {
    const dateRangeComp = useRef({
        date_from: moment().startOf('day').format("YYYY-MM-DD"), // Start from today
        date_until: moment().endOf('year').add(1, 'year').format("YYYY-MM-DD") // End on 31st Dec next year
    });
    const [dateDisplay, setDateDisplay] = useState({ ...dateRangeComp.current })
    const compCalendarDates = useRef([]);
    const [calendarDates, setCalendarDates] = useState([]);
    //const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const weekDays = ["S", "M", "T", "W", "T", "F", "S"];
    const [selectedWeekDays, setSelectedWeekDays] = useState([]);
    const [selectedWeekNumbers, setSelectedWeekNumbers] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(moment(asOfDate).format("MM"));
    useEffect(() => {
        let isSubscribed = true;
        const numDates = getNumDaysFromDateRange(dateRangeComp.current);
        const calendarDates = [];
        for (let index = 0; index < numDates; index++) {
            calendarDates.push({
                date: moment(dateRangeComp.current.date_from).add(index, 'days').format("YYYY-MM-DD"),
            })

        }
        compCalendarDates.current = calendarDates;
        setCalendarDates(prev => {
            return calendarDates;
        })

        return () => {
            isSubscribed = false;
        }
    }, [dateDisplay])
    useEffect(() => {
        console.log(selectedDates);
        compCalendarDates.current = compCalendarDates.current.map(item => {
            if (selectedDates.find(i => i.date === item.date)) {
                item.active = true;
            } else {

                item.active = false;
                let weekStart = moment(item.date).startOf("week");
                const weekNum = moment(weekStart).week();
                const weekIndex = selectedWeekNumbers.indexOf(weekNum)
                if (weekIndex > -1) { // only splice array when item is found
                    selectedWeekNumbers.splice(weekIndex, 1);
                }
            }
            return item;
        });
        setSelectedWeekNumbers(prev => [...selectedWeekNumbers]);
        setCalendarDates(prev => {
            return [...compCalendarDates.current];
        })
    }, [selectedDates])
    const updateCalendarDates = (curr_date, type, active) => {
        if (type === "date") {
            compCalendarDates.current = compCalendarDates.current.map(item => {
                if (curr_date === item.date) {
                    item.active = active;

                }
                return item;
            })
            if (active === false) {
                const weekday = moment(curr_date).format("ddd");
                const index = selectedWeekDays.indexOf(weekday);
                if (index > -1) { // only splice array when item is found
                    selectedWeekDays.splice(index, 1);
                }
                setSelectedWeekDays(prev => [...selectedWeekDays])
                let weekStart = moment(curr_date).startOf("week");
                const weekNum = moment(weekStart).week();
                const weekIndex = selectedWeekNumbers.indexOf(weekNum)
                if (weekIndex > -1) { // only splice array when item is found
                    selectedWeekNumbers.splice(weekIndex, 1);
                }
                setSelectedWeekNumbers(prev => [...selectedWeekNumbers]);
            }
            setCalendarDates(prev => {
                return [...compCalendarDates.current];
            })
        }
        if (type === "week") {
            let weekStart = curr_date;
            let weekEnd = moment(curr_date).endOf("week");
            compCalendarDates.current = compCalendarDates.current.map(item => {
                if (moment(item.date).isBetween(weekStart, weekEnd, "day", "[]")) {
                    item.active = active;

                }
                return item;
            })
            setCalendarDates(prev => {
                return [...compCalendarDates.current];
            })
            const weekNum = moment(weekStart).week();
            let index = selectedWeekNumbers.indexOf(weekNum)
            if (active === true) {
                if (index < 0) {
                    selectedWeekNumbers.push(weekNum);
                }
            }
            if (active === false) {
                if (index > -1) {
                    selectedWeekNumbers.splice(index, 1)
                }
            }
            setSelectedWeekNumbers(prev => [...selectedWeekNumbers]);

        }
        if (type === "dayOfweek") {

            compCalendarDates.current = compCalendarDates.current.map(item => {
                if (moment(item.date).format("ddd") === curr_date) {
                    item.active = active;
                }
                return item;
            })
            setCalendarDates(prev => {
                return [...compCalendarDates.current];
            })
        }
        modifyCalendarDates(compCalendarDates.current)

    }


    const calendarSelection = () => {
        // const numWeeks = getNumWeeks(dateRangeComp);
        const numMonths = getNumMonths({
            date_from: moment(dateRangeComp.current.date_from).startOf("month").format("YYYY-MM-DD"),
            date_until: moment(dateRangeComp.current.date_until).endOf("month").format("YYYY-MM-DD")
        });
        const months = [];
        console.log("Num Months", numMonths)
        let weekCount = moment(dateRangeComp.current.date_from).week();
        let numWeeks = 0;
        let weekslist = [];
        let calendar = [];
        for (let monthCount = 0; monthCount < numMonths; monthCount++) {
            const weeks = [];
            let currMonth = moment(dateRangeComp.current.date_from).add(monthCount, "months").startOf("month").format("YYYY-MM-DD");
            let startDate = moment(dateRangeComp.current.date_from).startOf("month").add(monthCount, "months").startOf("week").format("YYYY-MM-DD");
            let endDate = moment(dateRangeComp.current.date_from).add(monthCount, "months").endOf("month").endOf("week").format("YYYY-MM-DD");
            let weeksInMonth = getNumWeeks({ date_from: startDate, date_until: endDate });

            for (let j = 0; j < weeksInMonth; j++) {
                const currentWeek = moment(startDate).add(j, "weeks")
                    .startOf("week").format("YYYY-MM-DD");
                if (moment(currentWeek).isAfter(dateRangeComp.current.date_until)) {
                    break;
                }
                if (moment(currentWeek).isBefore(moment(dateRangeComp.current.date_from).startOf("week"))) {
                    continue;
                }
                weekCount = moment(startDate).add(j, "weeks").week();
                const activeWeek = (selectedWeekNumbers.indexOf(weekCount) > -1) ? true : false
                weeks.push(<Week currMonth={currMonth}
                    currentWeek={currentWeek}
                    weekCount={weekCount}
                    dateRange={dateRangeComp.current} calendarDates={calendarDates}
                    activeWeek={activeWeek}
                    updateCalendarDates={updateCalendarDates} />);

            }
            months.push(<div className="calendar-month">
                <div className='month-heading'>{moment(currMonth).format("MMM YYYY")}</div>
                {weeks}
            </div>);
        }
        return (<>{months}</>)
    }
    const changedateRangeComp = (value, type) => {


        if (type === "date_from") {
            setDateDisplay(prev => {
                return { ...prev, date_from: value }
            })
            if (moment(value).isValid() && value.length === 10 &&
                moment(value).isSameOrAfter(asOfDate) &&
                moment(dateRangeComp.current.date_until).diff(value, 'years') < 2 &&
                moment(dateRangeComp.current.date_until).diff(value, 'days') >= 0) {
                dateRangeComp.current.date_from = value;
                changeDateRange(dateRangeComp.current)
            }
        }
        else if (type === "date_until") {
            setDateDisplay(prev => {
                return { ...prev, date_until: value }
            })
            if (moment(value).isValid()) {
                dateRangeComp.current.date_until = value;

                changeDateRange(dateRangeComp.current)
            }
        }
    }

    const handleScroll = () => {
        const calendarContainer = calendarContainerRef.current;

        if (calendarContainer) {
            // Check if the user has scrolled to the bottom
            if (calendarContainer.scrollHeight -  Math.ceil(calendarContainer.scrollTop) === calendarContainer.clientHeight) {
                // Load next 12 months
                const currentYear = moment(dateRangeComp.current.date_until).year();
                const nextYear = moment(dateRangeComp.current.date_until).add(1, 'year').year();
                const nextEndDate = nextYear + "-12-31";

                console.log("currentYear", currentYear);
                console.log("nextYear", nextYear);
                changedateRangeComp(nextEndDate, "date_until")
            }
        }
    };

    const calendarContainerRef = useRef(null);

    useEffect(() => {
        if (rangeInput === "disabled") {
            const calendarContainer = calendarContainerRef.current;
            if (calendarContainer) {
                calendarContainer.addEventListener('scroll', handleScroll);
            }

            return () => {
                if (calendarContainer) {
                    calendarContainer.removeEventListener('scroll', handleScroll);
                }
            };
        }
    }, [dateDisplay]);

    const weekdaysHeader = (
        <header className="calendar-header" style={{ display: "flex", gap: "8px" }}>
            <TextField
                label="Date From"
                size="small"
                id="date-from"
                className='date-picker'
                onChange={e => {
                    changedateRangeComp(e.target.value, "date_from")
                }} value={dateDisplay.date_from}

            />
            <TextField
                label="Date Until"
                size="small"
                id="date-until"
                className='date-picker'
                onChange={e => {
                    changedateRangeComp(e.target.value, "date_until")
                }}
                value={dateDisplay.date_until}
            />
        </header>)

    return (

        <div className="calendar-container">
            {/**/}
            {rangeInput === "enabled" && weekdaysHeader}
            <Box className="calendar-body">
                <ul className="calendar-weekdays">
                    {weekDays.map((item, index) => {
                        let activeClass = (selectedWeekDays.indexOf(item) > -1) ? "active" : "";

                        return (
                            <li class={"week-day-item " + activeClass} onClick={(e) => {
                                if (weekdaysSelection === "disabled") {
                                    e.preventDefault();
                                    return;
                                }
                                let findIndex = selectedWeekDays.indexOf(item)
                                if (findIndex < 0) {
                                    selectedWeekDays.push(item);
                                    updateCalendarDates(item, "dayOfweek", true);
                                } else {
                                    selectedWeekDays.splice(findIndex, 1);
                                    updateCalendarDates(item, "dayOfweek", false);
                                }
                                setSelectedWeekDays(prev => selectedWeekDays);

                            }} key={index} >{item}</li>
                            // <li class={"week-day-item " + activeClass}>{item}</li>
                        )
                    })}
                </ul>
                <div className="calendar-selection" ref={calendarContainerRef}>
                    {calendarSelection()}
                </div>
            </Box>
        </div>
    )
}

export default GroupCustomCalendar
